import React from 'react'

import {Breadcrumb, Layout, Modal, message, Spin, Divider, Row, Col} from 'antd'
import SplitterLayout from 'react-splitter-layout'
import 'react-splitter-layout/lib/index.css'
import './videos.css'
import _ from 'lodash'
import Settings from '../commons/StatelessSettings'
import SettingsHandler from '../commons/SettingsHandler'
import ModalCarousel from './ModalCarousel'
import videoService from '../services/video.service'
import fileUploadService from '../services/file.upload.service'
import fileDownloadService from '../services/file.download.service'
import authService from '../services/authentication.service'
import userService from '../services/users.service'
import * as constants from '../commons/constants'
import {findFolder, getFolderPath, isAncestor} from '../utils/functions'
import { comparator} from '../utils/functions'
import GenericModal from '../commons/GenericModal'
import SmallVideo from './SmallVideo'
import FolderTree from '../commons/FolderTree'
import Toolbar from '../commons/Toolbar'
import {Input} from "antd/lib/index";

const {Content, Sider} = Layout
const {confirm} = Modal
const {Search} = Input



class VideosView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            collapsed: true,
            loadingTree: true,
            treeData: [],
            selectedFolder: {
                _id: null,
            },
            modal: {
                visible: false,
                action: null,
                data: [],
            },
            videos: [],
            folderPath: 'Videos',
            expandedKeys: [],
            selectedVideos: [],
            users: [],
            carouselVisible: false,
        }
        this.upload = null
        this.ctrlKey = false
        this.selectedFolderName = ''
        this.currentTreeAction = ''
        this.smallVideos = {}
        this.settingsHandler = new SettingsHandler(this, videoService);
        this.user = authService.getAuthenticatedUser()
    }

    getFirstSelectedFile = () => {
        return !_.isEmpty(this.state.selectedVideos)
            ? this.state.selectedVideos[0].props.file
            : undefined
    }

    getSelectedVideoIndex = () => {
        if (this.state.selectedVideos.length == 1) {
            const selected = this.state.selectedVideos[0].props.file
            return _.findIndex(this.state.videos, p => p._id == selected._id)
        }
        return 0
    }

    handleOnClickMenu = ({item, key, keyPath, domEvent}) => {
        domEvent.preventDefault()
        domEvent.stopPropagation()
        console.log('handleOnClickMenu:', item, key)
        this.currentTreeAction = key
        if (key === constants.UPLOAD_FILES) {
            this.upload.click()
        }

        if (key === constants.ADD_FOLDER) {
            this.setState({
                modal: {
                    visible: true,
                    action: key,
                    data: '',
                },
            })
        }

        if (key === constants.RENAME_FOLDER) {
            this.setState({
                modal: {
                    visible: true,
                    action: key,
                    data: this.selectedFolderName,
                },
            })
        }

        if (key == constants.CUT_FOLDER) {
            this.cutFolderId = this.state.selectedFolder._id;
        }

        if (key == constants.PASTE_FOLDER) {

            this.moveFolder(this.cutFolderId, this.state.selectedFolder._id)
            this.cutFolderId = null;
        }

        if (key == constants.DELETE_FOLDER) {
            this.deleteFolder(this.state.selectedFolder)
        }

    }

    handleModalOk = async data => {
        console.log(data)

        if (this.currentTreeAction === constants.ADD_FOLDER) {
            //passing iconCls to keep backward compatibility
            const folder = {
                text: data,
                iconCls: 'icon-folder-open',
                _parentId: this.state.selectedFolder._id,
            }

            const savedFolder = await videoService.saveFolder(
                folder,
                this.state.folderPath
            )

            if (!this.state.selectedFolder.children) {
                this.state.selectedFolder.children = []
            }
            this.state.selectedFolder.children.push(savedFolder)
            this.state.selectedFolder.children.sort(comparator);

            this.state.expandedKeys.push(savedFolder._id)
            console.log('expandedKey:', this.state.expandedKeys)
            this.setState({
                treeData: this.state.treeData,
                selectedFolder: savedFolder,
                expandedKeys: this.state.expandedKeys,
            })
        }

        if (this.currentTreeAction === constants.RENAME_FOLDER) {
            const folder = this.state.selectedFolder
            folder.text = data
            const savedFolder = await videoService.saveFolder(
                folder,
                this.state.folderPath
            )
            const parentFolder = findFolder(folder._parentId, this.state.treeData);
            parentFolder.children.sort(comparator);
            this.setState({treeData: this.state.treeData})
        }
        this.closeModal()
    }

    closeModal = () => {
        this.setState({modal: {visible: false, data: {}}})
    }

    setUploadProgress = (filename, percent, status) => {
        const data = this.state.modal.data
        data[filename] = {name: filename, percent: percent, status: status}
        this.setState({
            modal: {visible: true, action: constants.UPLOAD_FILES, data: data},
        })
    }

    handleOnUploadProgress = (filename, percent) => {
        console.log('handleOnUploadProgress', filename, percent)
        this.setUploadProgress(filename, percent, 'active')
    }

    handleOnChangeFile = event => {
        event.stopPropagation()
        event.preventDefault()
        const files = event.target.files
        const folderId = this.state.selectedFolder._id
        let data = {}
        for (let file of files) {
            data[file.name] = {name: file.name, percent: 0, status: 'active'}
            fileUploadService
                .sendFile(file, {
                    name: 'documents',
                    params: {
                        folderId: folderId,
                        folderPath: getFolderPath(this.state.treeData, folderId),
                    },
                    onProgress: this.handleOnUploadProgress,
                    url: '/api/v1/videos/upload',
                })
                .then(file => {
                    console.log('file uploaded successfully', file)
                    this.setUploadProgress(file.originalname, 100, 'success')
                    this.setState({videos: [...this.state.videos, file]})
                })
                .catch(error => {
                    console.log('error uploading file', error)
                    this.setUploadProgress(error.filename, 100, 'exception')
                })
        }
        this.setState({modal: {visible: true, action: 'upload', data: data}})
    }

    removeHighlight = () => {
        this.state.selectedVideos.forEach(c => c.setHighlight(false))
        this.state.selectedVideos = []
    }

    handleOnSelectVideo = component => {
        if (!this.ctrlKey) {
            this.removeHighlight()
        }
        component.setHighlight(true)

        this.state.selectedVideos.push(component)

        this.setState({selectedVideos: this.state.selectedVideos})

        this.updateSettings(this.state.selectedFolder,
            component.props.file, this.state.settings.users);
    }

    handleDownload = () => {
        if (this.state.selectedVideos.length == 1) {
            const file = this.state.selectedVideos[0].props.file
            const url = `/api/v1/videos/file/download/?fileId=${file._id}&folderPath=${this.state.folderPath}`
            window.open(url);
            //fileDownloadService.download(url, file.originalname)
        }
    }

    handleDelete = () => {
        confirm({
            title: 'Are you sure you want to delete these videos?',
            content: 'After clicking OK the videos will be deleted permanently',
            onOk: async () => {
                console.log('OK')
                for (let comp of this.state.selectedVideos) {
                    await videoService.deleteVideo(comp.props.file._id)
                }
                const filtered = this.state.videos.filter(p => {
                    let found = false
                    for (let comp of this.state.selectedVideos) {
                        if (comp.props.file._id == p._id) {
                            found = true
                            break
                        }
                    }
                    return !found
                })
                this.setState({videos: filtered})
            },
            onCancel() {
                console.log('Cancel')
            },
        })
    }


    handleLoadData = treeNode => {
        const folderId = treeNode.props.dataRef._id;
        console.log('handleLoadData: folderId=', folderId);
        return new Promise(resolve => {
            if (!_.isEmpty(treeNode.props.children)) {
                resolve();
                return;
            }
            videoService.getTreeData(folderId).then(data => {
                treeNode.props.dataRef.children = data;
                this.setState({
                    treeData: [...this.state.treeData]
                });
                resolve();
            }).catch(error => {
                console.error(error)
            });
        });
    }

    moveFiles = async (fileIds, folderId, dnd = true) => {
        console.log('moveFiles:', fileIds, folderId, dnd)
        const rsp = await videoService.moveFiles(fileIds, folderId)
        if (rsp.rspCode === 'ok') {
            if (dnd) {
                const filtered = _.filter(
                    this.state.videos,
                    p => !fileIds.includes(p._id)
                )
                this.setState({videos: filtered})
                this.removeHighlight()
            }
            else { //cut and paste
                const videos = await videoService.getVideos(folderId)
                this.setState({videos: videos})
            }
            message.success('Files moved successfully')
        } else {
            message.error('Error occurred while moving files')
        }
        console.log('moveFiles:', rsp)
    }

    moveFolder = async (srcFolderId, targetFolderId) => {
        console.log('moveFolder:', srcFolderId, targetFolderId)

        if (isAncestor(srcFolderId, targetFolderId, this.state.treeData)) {
            message.error("Cannot move folder to one of its children...")
            return;
        }

        if (srcFolderId === targetFolderId) return;

        const rsp = await videoService.moveFolder(srcFolderId, targetFolderId)
        if (rsp.rspCode === 'ok') {
            /**  This logic needs to be optimized **/
            const srcFolder = findFolder(srcFolderId, this.state.treeData)
            const srcParent = findFolder(srcFolder._parentId, this.state.treeData)
            const targetFolder = findFolder(targetFolderId, this.state.treeData)
            srcFolder._parentId = targetFolder._id
            if (!targetFolder.children) targetFolder.children = []
            targetFolder.children.push(srcFolder)
            _.remove(srcParent.children, child => {
                return child._id === srcFolder._id
            })
            this.setState({
                folderPath: getFolderPath(this.state.treeData, srcFolderId),
            })
            this.setState({treeData: this.state.treeData})
            message.success('Folder moved successfully')
        } else {
            message.error('Error occurred while moving folder')
        }
        console.log('moveFolder:', rsp)
    }

    deleteFolder = async (folder) => {
        const folderId = folder._id;
        confirm({
            title: 'Are you sure you want to delete this Folder?',
            content: 'After clicking OK folder will be deleted',
            onOk: async () => {
                const rsp = await videoService.deleteFolder(folderId)
                if (rsp.rspCode === "error") {
                    message.error(rsp.msg);
                }
                else {
                    const parent = findFolder(folder._parentId, this.state.treeData)
                    _.remove(parent.children, child => {
                        return child._id === folder._id
                    })
                    this.setState({treeData: this.state.treeData})
                    message.success('Folder delete successfully')
                }
            },
            onCancel() {
                console.log('Cancel')
            },
        })
    }

    showSettings = () => {
        const collapsed = this.state.collapsed
        if (collapsed) {
            console.log('something is wrong. This should never happen!!!')
        }
        if ((collapsed) || (!collapsed)) {
            this.setState({
                collapsed: !collapsed,
            })
        }
    }

    onSelect = async (keys, event) => {
        const node = event.selectedNodes[0]
        const folderId = keys[0]
        const selectedFolder = findFolder(folderId, this.state.treeData)
        this.setState({
            selectedFolder: selectedFolder,
            folderPath: getFolderPath(this.state.treeData, folderId),
        })
        this.updateSettings(selectedFolder, null, this.state.settings.users);
        const videos = await videoService.getVideos(keys[0])
        this.selectedFolderName = node.props.dataRef.text
        this.setState({videos: videos})
    }

    onExpand = keys => {
        console.log('Trigger Expand', keys)
        this.setState({expandedKeys: keys})
    }

    componentDidMount() {
        videoService
            .getTreeData()
            .then(data => {
                this.setState({
                    treeData: data,
                    selectedFolder: data[0],
                    expandedKeys: [data[0]._id],
                    loadingTree: false,
                })

                return userService.getUsers();
            })
            .then(users => {
                this.updateSettings(this.state.selectedFolder, null, users);
            })
            .catch(error => {
                console.log(error)
            })
    }

    updateSettings = (folder, file, users) => {
        const folderLink = folder.publicLink
        const securityDetail = folder.securityDetail
        const selectedOwner = securityDetail ? securityDetail.owner : ''

        const selectedGuests = securityDetail
            ? _.map(securityDetail.guests, g => g.username)
            : []

        const iconColor = folder.stateColor
        let textStyle = []
        if (folder.textBoldStyle)
            textStyle.push(folder.textBoldStyle.value)
        if (folder.textItalicStyle)
            textStyle.push(folder.textItalicStyle.value)

        const textSize = folder.textSize ? folder.textSize.option : undefined
        const folderComments = folder.comments
        const fileComments = file ? file.comments : ''
        const fileLink = file ? file.publicLink : ''

        this.setState({
            settings: {
                selectedOwner: selectedOwner,
                selectedGuests: selectedGuests,
                users: users,
                folderLink: folderLink,
                iconColor: iconColor,
                textSize: textSize,
                textStyle: textStyle,
                file: file,
                fileComments: fileComments,
                fileLink: fileLink,
                folderComments: folderComments
            }
        });
    }

    renderVideoContainer = videos => {
        this.smallVideos = {}
        const list = []
        for (let video of videos) {
            let smallVideo = (
                <SmallVideo
                    key={video._id}
                    file={video}
                    onClick={this.handleOnSelectVideo}
                    onDoubleClick={e => {
                        console.log('double clicking video', e)
                        this.setState({carouselVisible: true})
                    }}
                    ref={e => {
                        this.smallVideos[video._id] = e
                    }}
                />
            )
            list.push(smallVideo)
        }
        return list
    }

    renderBreadCrums = folderPath => {
        const paths = folderPath.split('/')
        return paths.map(p => {
            if (p.trim() !== '') {
                return <Breadcrumb.Item> {p}</Breadcrumb.Item>
            }
        })
    }

    render() {

        const owner = this.user.isFolderOwner(this.state.selectedFolder)
        const admin = this.user.hasRole(['Administrator']);
        const supervisor = this.user.hasRole(['Supervisor']);

        const toolBarItems = [
            {
                title: 'cut',
                icon: 'scissor',
                onClick: () => {
                    this.cutVideosIds = this.state.selectedVideos.map(p => {
                        return p.props.file._id;
                    })
                },
                display: admin || owner
            },
            {
                title: 'paste',
                icon: 'snippets',
                onClick: () => {
                    this.moveFiles(this.cutVideosIds, this.state.selectedFolder._id, false)
                    this.cutVideosIds = null
                },
                display: admin || owner
            },
            {
                title: 'delete',
                icon: 'delete',
                onClick: () => this.handleDelete(),
                display: admin || supervisor || owner
            },
            {
                title: 'download',
                icon: 'download',
                onClick: () => this.handleDownload(),
                display: true
            },
            {
                title: 'settings',
                icon: 'setting',
                onClick: () => this.showSettings(),
                display: admin || supervisor || owner
            },
        ]
        return (
            <div style={{flex: '1 1 auto', display: 'flex', flexDirection: 'column'}}>
                <input
                    type="file"
                    id="file"
                    ref={e => {
                        this.upload = e
                    }}
                    style={{display: 'none'}}
                    multiple
                    onChange={this.handleOnChangeFile}
                />
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        {this.renderBreadCrums(this.state.folderPath)}
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={12}>
                        <Row type="flex" justify="start">
                            <Search
                                onSearch={value => {
                                    this.setState(
                                        {
                                            searchString: value,
                                        },
                                    )
                                }}
                                style={{width: 330}}
                            />
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>
                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>

                <div id="videoContentPanel" style={{flex: 'auto', display: 'flex', flexDirection: 'column', overflow: 'auto', boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)',}}>
                    <SplitterLayout primaryIndex={1} secondaryInitialSize={225}>
                        <Spin spinning={this.state.loadingTree} tip="Loading tree...">
                            <div style={{flex: 'auto', display: 'flex', flexDirection: 'column', height: '100px', overflowY: 'auto'}}>
                                <FolderTree
                                    onSelect={this.onSelect}
                                    onExpand={this.onExpand}
                                    selectedKeys={[this.state.selectedFolder._id]}
                                    expandedKeys={this.state.expandedKeys}
                                    treeData={this.state.treeData}
                                    onClickMenu={this.handleOnClickMenu}
                                    onMoveFiles={this.moveFiles}
                                    onMoveFolder={this.moveFolder}
                                    onLoadData={this.handleLoadData}
                                    permissions={this.state.selectedFolder.allowedActions}
                                />
                            </div>
                        </Spin>
                        <div
                            id="videoContainer"
                            style={{
                                flex: '1 1 auto',
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden'
                            }}
                        >
                            <Layout>
                                <Content>
                                    <div
                                        onKeyDown={e => {
                                            this.ctrlKey = e.ctrlKey
                                        }}
                                        onKeyUp={e => {
                                            this.ctrlKey = e.ctrlKey
                                        }}
                                        tabIndex="0"
                                        style={{
                                            flex: '1 1 auto',
                                            overflow: 'auto',
                                            height: '100px',
                                            background: 'white',
                                        }}
                                    >
                                        {this.renderVideoContainer(this.state.videos)}
                                    </div>
                                </Content>

                                <Sider
                                    trigger={null}
                                    collapsible
                                    collapsed={this.state.collapsed}
                                    style={{background: '#fff'}}
                                    width={450}
                                    collapsedWidth={0}
                                >
                                    <div style={{padding: '10px', height:'100px' }}>
                                        {!this.state.collapsed ? (
                                            <Settings
                                                data={this.state.settings}
                                                handler={this.settingsHandler}
                                                shareFolder={true}
                                                shareFile={true}
                                                authUser={this.user}
                                            />
                                        ) : null}
                                    </div>
                                </Sider>
                            </Layout>
                        </div>
                    </SplitterLayout>
                </div>

                <GenericModal
                    visible={this.state.modal.visible}
                    onOk={this.handleModalOk}
                    onCancel={this.closeModal}
                    data={this.state.modal.data}
                    action={this.state.modal.action}
                />
                <ModalCarousel
                    visible={this.state.carouselVisible}
                    videos={this.state.videos}
                    initialSlide={this.getSelectedVideoIndex()}
                    onCancel={() => {
                        this.setState({carouselVisible: false})
                    }}
                />
            </div>
        )
    }
}

export default VideosView
